import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { serverUrl } from "../../Constant/Static/config";
import userIcon from "../../Constant/Icons/user.svg";
import peopleIcon from "../../Constant/Icons/people.svg";
import userName from "../../Constant/Icons/username.svg";
import passwordIcon from "../../Constant/Icons/password.svg";
import PopModal from "../../Constant/Custom/Models/PopModal";
import { AuthContext } from "../../Auth/AuthContext";
import VerifierHeader from "../Components/VerifierHeader";

function VerifierLogin() {
  const { loginVerifier } = useContext(AuthContext);
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const navigate = useNavigate();
   const [isAllowed, setIsAllowed] = useState(false);
  const [response, setResponse] = useState('')
  
  useEffect(() => {
    const restrict = async () => {
      const response = await axios.post(`${serverUrl}/api/check-ip`)
      if (response.status === 200) {
        setIsAllowed(true)
        setResponse(response.data.ip);
      }
      else {
        setIsAllowed(false)
        setResponse(response.data.ip);
      }
    }
    restrict();
  }, []);

  if (!isAllowed) {
    return (
      null
    );
  }



  // const [isAllowed, setIsAllowed] = useState(false);
  // const [response, setResponse] = useState('')
  // useEffect(() => {
  //   const restrict = async () => {
  //     const response = await axios.post(`${serverUrl}/api/check-ip`)
  //     if (response.status === 200) {
  //       setIsAllowed(true)
  //       setResponse(response.data.ip);
  //     }
  //     else {
  //       setIsAllowed(false)
  //       setResponse(response.data.ip);
  //     }
  //   }
  //   restrict();
  // }, []);

  // if (!isAllowed) {
  //   return (
  //     null
  //   );
  // }
  

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.username.trim() || !formData.password.trim()) {
      setModalType({
        icon: "warning",
        title: "Invalid Input",
        text: "Username and password cannot be empty.",
      });
      openModal();
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await axios.post(`${serverUrl}/api/cv/login`, {
        username: formData.username.trim(),
        password: formData.password.trim(),
      });

      if (response.status === 200 && response.data.token) {
        setModalType({
          icon: "success",
          title: "Login Successful!",
          text: response.data.message,
        });
        openModal();
        loginVerifier(response.data.token);
        setTimeout(() => navigate("/cv/verifier/dashboard"), 500);
      } else {
        throw new Error(response.data.message || "Login failed.");
      }
    } catch (err) {
      if (err.response?.status == 401) {
        setModalType({
          icon: "error",
          title: "UnAuthorized!",
          text: "Verfier not allowed.Please contact TNLEA Team!",
        });
        openModal();
      } else {
        const errorMessage =
          err.response?.data?.message || "An error occurred. Please try again.";
        setModalType({
          icon: "error",
          title: "Login Failed!",
          text: errorMessage,
        });
        openModal();
      }

      //   console.error(errorMessage);
    }
  };

  const handleCancel = () => {
    setFormData({ username: "", password: "" });
    closeModal();
  };

  return (
    <div
      style={{ width: "100dvw", height: "100dvh", backgroundColor: "#f9f9f9" }}
    >
      <VerifierHeader>
        <a href="/cv/login">
          <img src={userIcon} alt="Login" width={50} height={50} />
        </a>
      </VerifierHeader>
      <div className="login-container">
        <div className="login-inner-container">
          <img src={peopleIcon} alt="user" width={75} height={75} />
          <form onSubmit={handleSubmit}>
            <div className="login-form-group">
              <input
                type="text"
                name="username"
                value={formData.username}
                placeholder="Enter Phone Number"
                onChange={handleChange}
                required
              />
              <img
                className="IconForInput"
                src={userName}
                alt="user"
                width={20}
                height={20}
              />
            </div>
            <div className="login-form-group">
              <input
                type="password"
                name="password"
                value={formData.password}
                placeholder="Enter Password"
                onChange={handleChange}
                required
              />
              <img
                className="IconForInput"
                src={passwordIcon}
                alt="user"
                width={20}
                height={20}
              />
            </div>
            <div className="login-form-group" style={{ alignSelf: "flex-end" }}>
              <a href="/cv/forgot-password" className="forgot-password-link">
                Forgot Password?
              </a>
            </div>
            <div className="login-form-group">
              <button type="submit" className="login-button">
                LogIn
              </button>
            </div>
          </form>
          <div
            style={{
              position: "relative",
              alignSelf: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <svg height={10} width="100%" xmlns="http://www.w3.org/2000/svg">
              <line
                x1="0%"
                y1="55%"
                x2="100%"
                y2="55%"
                style={{
                  stroke: "#1C274C",
                  strokeWidth: 0.25,
                  filter: "drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))",
                }}
              />
            </svg>
            <div
              style={{
                position: "absolute",
                backgroundColor: "#f9f9f9",
                padding: "5px 5px",
                borderRadius: "50%",
                zIndex: "1000",
              }}
            >
              <h6 style={{ margin: 0 }}>Or</h6>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0% 2%",
            }}
          >
            <h5 style={{ color: "#1C274C" }}>
              <a href="/cv/register" className="apply-register">
                New Registration?
              </a>
            </h5>
          </div>
          <div
            style={{
              position: "relative",
              alignSelf: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <PopModal
              isOpen={isModalOpen}
              type={modalType}
              confirmButtonText="OK"
              onConfirm={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifierLogin;
